module.exports = __webpack_public_path__ + "static/media/star-icon-gold.9475df44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/star-icon-gold.svg
// module id = ./src/assets/images/star-icon-gold.svg
// module chunks = 0